export default __webpack_public_path__ + "static/icon-17-2-bc835e51bf468dba92c7273dab176088.png";